/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} User_DataInputs */

const en_user_data = /** @type {(inputs: User_DataInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`User data`)
};

const de_user_data = /** @type {(inputs: User_DataInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nutzerdaten`)
};

/**
* | output |
* | --- |
* | "User data" |
*
* @param {User_DataInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const user_data = /** @type {((inputs?: User_DataInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<User_DataInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_user_data(inputs)
	return en_user_data(inputs)
});